"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.NColumnCanvasComponent = void 0;
require('../n-column-canvas/n-column-canvas.component.css');
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var NColumnCanvasComponent = /** @class */ (function () {
    function NColumnCanvasComponent($rootScope, $scope, $timeout) {
        this.stickyList = {};
        this.issueConfigWithTitle = {};
        this.colWidthPerc = '25%';
        this.disableEdit = false;
        this.isOverflown = function (_a) {
            var clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
            return scrollHeight > clientHeight;
        };
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.N_COL_CANVAS);
        ctrl.debounceValue = ctrl.utilsService.debounceDefault;
        ctrl.$scope = $scope;
        ctrl.$rootScope = $rootScope;
        ctrl.options = { show: true, id: -1 };
        ctrl.$timeout = $timeout;
        ctrl.initListeners(ctrl);
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $timeout();
    }
    NColumnCanvasComponent.prototype.initListeners = function (ctrl) {
        ctrl.initBootstrapListeners(ctrl);
        ctrl.initDragListeners(ctrl);
        ctrl.initDropListeners(ctrl);
    };
    NColumnCanvasComponent.prototype.initBootstrapListeners = function (ctrl) {
        ctrl.$scope.$on('saveNColCanvas', function (event, args) {
            ctrl.selectedIssue = __assign({}, args.selectedIssue);
            ctrl.saveFromDialog();
        });
        ctrl.$scope.$on('command:N_COLUMN_CANVAS', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.initComponent(event, args);
            ctrl.$scope.$emit('workbench:loading', { 'load': false });
        });
    };
    NColumnCanvasComponent.prototype.onStickyChange = function (key, stickyIndex, note) {
        var ctrl = this;
        ctrl.updateChangeDate(key, stickyIndex);
        ctrl.utilsService.setFontSize(note, key, stickyIndex);
        ctrl.saveIssueData(note._id, key);
    };
    NColumnCanvasComponent.prototype.initDragListeners = function (ctrl) {
        ctrl.$scope.$on('DragStart', function (event, args) {
            // console.log(args.id);
            ctrl.draggableItemId = args.id;
        });
        ctrl.$scope.$on('DragOver', function (event, args) {
            var el = document.getElementById(ctrl.draggableItemId);
            el.style.backgroundColor = ctrl.issueConfigWithTitle[args.type].color;
            el.style.opacity = '0.4';
            var divCollection = [].slice.call(args.container[0].children);
            var dragAfterElement = ctrl.utilsService.getDragElement(divCollection, args.event.clientY);
            if (dragAfterElement) {
                // To get the target index of draggable item to be placed
                divCollection.find(function (x, index) {
                    ctrl.dropIndex = index;
                    return x == dragAfterElement;
                });
            }
            args.container[0].insertBefore(el.parentElement, dragAfterElement);
        });
        ctrl.$scope.$on('DragEnd', function (event, args) {
            var dragEl = document.getElementById(ctrl.draggableItemId);
            if (dragEl) {
                dragEl.style.opacity = "1.0";
            }
        });
    };
    NColumnCanvasComponent.prototype.initDropListeners = function (ctrl) {
        ctrl.$scope.$on('CopiedFromAllStickies', function (event, args) {
            ctrl.copiedFromAllStickies = args.status;
        });
        ctrl.$scope.$on('Drop', function (event, args) {
            ctrl.setIssueDetails(args.type, ctrl.stickyList[args.type], args);
        });
    };
    NColumnCanvasComponent.prototype.setIssueDetails = function (type, array, args) {
        var ctrl = this;
        // Assuming moving from feasibility:0 (drag location) to desirability:2 (drop location)
        // Remove from drag location but when drop it to some other location (Either other index, or other dropzone)
        var dragEl = document.getElementById(ctrl.draggableItemId);
        var dragElArray = ctrl.draggableItemId.split(":"); // [0]: type, [1]: index
        // When not dropped at same location i.e Same index and same zone
        if (!((dragElArray[0] == type) && (dragElArray[1] == ctrl.dropIndex))) {
            args.container[0].removeChild(dragEl.parentElement);
        }
        ctrl.issueDetails = ctrl.getDataAndRemove(args.dfv, args.id);
        var previousType = ctrl.issueDetails.type;
        ctrl.issueDetails.type = type;
        ctrl.issueDetails.backgroundColor = ctrl.issueConfigWithTitle[type].color;
        ctrl.issueDetails.updatedAt = ctrl.utilsService.updatedAt();
        //Add sticky to targeted position instead of end.
        array.splice(ctrl.dropIndex, 0, ctrl.issueDetails);
        // Set the opacity and color of updated element which has taken draggable item id
        if (dragEl) {
            dragEl.style.opacity = "1.0";
            dragEl.style.backgroundColor = ctrl.issueConfigWithTitle[previousType].color;
        }
        // Adjust height of zone
        Object.keys(ctrl.stickyList).forEach(function (type) {
            ctrl.stickyList[type].forEach(function (el) {
                el.isHeightUpdated = false;
            });
        });
        ctrl.saveIssueData(ctrl.issueDetails._id, ctrl.issueDetails.type);
        // ctrl.saveNColumnCanvas();
        ctrl.$scope.$apply();
    };
    NColumnCanvasComponent.prototype.deleteSticky = function (issueId, list) {
        var ctrl = this;
        for (var i = 0; i < list.length; i++) {
            if (issueId == list[i]._id) {
                list.splice(i, 1);
                break;
            }
        }
        // Adjust height of zone
        list.forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.deleteIssueById(issueId);
        // ctrl.saveNColumnCanvas();
    };
    NColumnCanvasComponent.prototype.deleteNode = function (issueId, list) {
        var ctrl = this;
        bootbox.dialog({
            message: "You are about to delete this issue. Are you sure?",
            title: "Confirm Deletion",
            buttons: {
                confirm: {
                    label: "Delete",
                    className: "btn-danger",
                    callback: function () {
                        ctrl.deleteSticky(issueId, list);
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    ;
    NColumnCanvasComponent.prototype.showIssueInfo = function (issueId) {
        var ctrl = this;
        bootbox.dialog({
            message: "Node Id: " + ctrl.node._id + " <br> Issue Id: " + issueId,
            title: "Issue Info",
            buttons: {
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    NColumnCanvasComponent.prototype.resetBack = function () {
        var ctrl = this;
        ctrl.selectedIssue = angular.copy(ctrl.origSelectedIssue);
    };
    NColumnCanvasComponent.prototype.checkDefaultSticky = function (dfv) {
        var ctrl = this;
        return dfv = ctrl.utilsService.issueType.DEFAULT.NAME ? 'default' : dfv;
    };
    NColumnCanvasComponent.prototype.getDataAndRemove = function (type, id) {
        var ctrl = this;
        var data = ctrl.stickyList[type][id];
        ctrl.removeIssueByIndex(ctrl.stickyList[type], id);
        return data;
    };
    NColumnCanvasComponent.prototype.updateChangeDate = function (dfv, id) {
        var ctrl = this;
        ctrl.stickyList[dfv][id].updatedAt = ctrl.utilsService.updatedAt();
    };
    NColumnCanvasComponent.prototype.addSticky = function () {
        var ctrl = this;
        // ctrl.allStickies.unshift(
        //     ctrl.utilsService.getNewSticky(ctrl.userName),
        // );
        if (ctrl.stickyList['default'].length == 0) {
            ctrl.stickyList['default'] = [];
        }
        var newGot = ctrl.utilsService.getNewSticky(ctrl.userName);
        // newGot.isDfv= true;
        ctrl.stickyList['default'].unshift(newGot);
        // Adjust height of zone
        ctrl.stickyList['default'].forEach(function (el) {
            el.isHeightUpdated = false;
        });
        ctrl.saveIssueData(newGot._id, 'default');
    };
    NColumnCanvasComponent.prototype.onEditSticky = function (issueId, list) {
        var ctrl = this;
        for (var i = 0; i < list.length; i++) {
            if (issueId == list[i]._id) {
                ctrl.selectedIssue = angular.copy(list[i]);
                ctrl.origSelectedIssue = list[i];
                ctrl.theIndex = i;
                ctrl.theList = list;
                ctrl.selectedIssue.prevType = ctrl.selectedIssue.type;
                ctrl.$timeout(function () {
                    console.log('emit');
                    ctrl.$scope.$emit('issueModal', { 'modalData': ctrl.modalData, 'selectedIssue': ctrl.selectedIssue, 'node': ctrl.node,
                        'issueList': issue_list_1.IssueListEnum.N_COL_CANVAS, fteGlobal: ctrl.fteGlobal });
                    ctrl.$scope.$apply();
                }, 1000);
                break;
            }
        }
    };
    NColumnCanvasComponent.prototype.clearSelection = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
    };
    NColumnCanvasComponent.prototype.setHoveredSticky = function (show, id) {
        var ctrl = this;
        ctrl.options = { show: true, id: id };
    };
    NColumnCanvasComponent.prototype.showIcons = function (id) {
        var ctrl = this;
        return ctrl.options.show == true && ctrl.options.id == id;
    };
    NColumnCanvasComponent.prototype.removeIssueByIndex = function (array, index) {
        if (index > -1) {
            array.splice(index, 1);
        }
    };
    NColumnCanvasComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.userName = args.userName;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.config = args.config;
        ctrl.fteGlobal = args.fte;
        ctrl.menu = [];
        ctrl.selectedIssue = null;
        ctrl.showMsg = false;
        ctrl.isQualitative = false;
        if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        }
        ctrl.getCanvasData();
    };
    NColumnCanvasComponent.prototype.getCanvasData = function () {
        var ctrl = this;
        ctrl.smartorg.getDFVData(ctrl.node._id).then(function (res) {
            if (res) {
                ctrl.initCanvasData(res);
                ctrl.$timeout();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    NColumnCanvasComponent.prototype.saveFromDialog = function () {
        var ctrl = this;
        ctrl.theList[ctrl.theIndex] = __assign({}, ctrl.selectedIssue);
        ctrl.showMsg = true;
        ctrl.saveIssueData(ctrl.selectedIssue._id, ctrl.selectedIssue.prevType);
    };
    NColumnCanvasComponent.prototype.saveIssueData = function (id, key) {
        var ctrl = this;
        // let selectedIssue = ctrl.issueDetails;
        // let impactToBeUsed = ctrl.isQualitative ? selectedIssue.impact : selectedIssue.calcImpact;
        // let issueToBeSaved = {
        //     '_id': selectedIssue._id,
        //     'name': selectedIssue.name,
        //     'ignorance': selectedIssue.ignorance,
        //     'impact': selectedIssue.impact,
        //     'calcImpact': selectedIssue.calcImpact,
        //     'score': selectedIssue.ignorance * impactToBeUsed,
        //     'type': selectedIssue.type,
        //     'impactMappingList': selectedIssue.impactMappingList,
        //     'updatedAt': selectedIssue.updatedAt,
        //     'isPotentialShowStopper': selectedIssue.isPotentialShowStopper,
        //     'abilityToLaunch': selectedIssue.abilityToLaunch,
        //     'inIterationPlan': selectedIssue.inIterationPlan,
        //     'startDate': selectedIssue.startDate,
        //     'endDate': selectedIssue.endDate,
        //     'experiments': selectedIssue.experiments
        // };
        var issueToBeSaved = ctrl.stickyList[key].find(function (x) { return x._id == id; });
        ctrl.smartorg.saveInavIssueData(issueToBeSaved, ctrl.node['_id']).then(function (res) {
            if (res) {
                if (ctrl.showMsg) {
                    ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
                        (issueToBeSaved['title'] ? issueToBeSaved['title'] : issueToBeSaved['name']) + '"');
                    ctrl.clearSelection();
                    ctrl.getCanvasData();
                    ctrl.showMsg = false;
                }
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    NColumnCanvasComponent.prototype.saveNColumnCanvas = function () {
        var ctrl = this;
        var data = JSON.parse(angular.toJson(ctrl.stickyList));
        ctrl.$timeout(function () {
            ctrl.smartorg.saveNColumnCanvasData(ctrl.node._id, data).then(function (ret) {
                if ('status' in ret && ret['status'] == 0) {
                    // ctrl.closeWarningDialog();
                    if (ctrl.showMsg) {
                        ctrl.showAlert('success', 'Success!', "Saved successfully.");
                        ctrl.clearSelection();
                        ctrl.getCanvasData();
                        // ctrl.clearAllObj();
                        ctrl.showMsg = false;
                    }
                    ctrl.$scope.$apply();
                }
                else {
                    ctrl.showAlert('danger', 'Error!', ret.message);
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
            });
        }, 500);
    };
    NColumnCanvasComponent.prototype.deleteIssueById = function (issueId) {
        var ctrl = this;
        ctrl.smartorg.deleteInavIssueById(ctrl.node._id, issueId).then(function (res) {
            if (res) {
                ctrl.showAlert('success', 'Deleted!', 'Issue has been deleted.');
                // ctrl.clearSelection();
                // ctrl.getCanvasData();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    NColumnCanvasComponent.prototype.formatIssueData = function (item) {
        var ctrl = this;
        item.description = 'description' in item ? item.description : "";
        item.title = item.title ? item.title : item.name.substring(0, 13);
        item.title = ctrl.utilsService.returnLimitedTitle(item);
        var impactToBeUsed = ctrl.isQualitative ? item.impact : item.calcImpact;
        // item.impact = impactToBeUsed;
        item.score = item.ignorance * impactToBeUsed;
        item.issueType = ctrl.utilsService.getDiscoveryGrid(item.ignorance, impactToBeUsed);
        if (item.experimentData.length > 0) {
            item.experimentData = item.experimentData[0];
        }
        else {
            item.experimentData.defined = 0;
        }
        var isDfv = false;
        var isSwot = false;
        if (item.type == this.utilsService.issueType.DESIRABILITY.NAME ||
            item.type == this.utilsService.issueType.FEASIBILITY.NAME ||
            item.type == this.utilsService.issueType.VIABILITY.NAME) {
            item.isDfv = true;
        }
        else if (item.type == this.utilsService.issueType.STRENGTHS.NAME ||
            item.type == this.utilsService.issueType.WEAKNESSES.NAME ||
            item.type == this.utilsService.issueType.OPPORTUNITIES.NAME ||
            item.type == this.utilsService.issueType.THREATS.NAME) {
            item.isSwot = true;
        }
        item.isHeightUpdated = false;
        item.showFooter = false;
        item.isDfv = isDfv;
        item.isSwot = isSwot;
        return item;
    };
    NColumnCanvasComponent.prototype.clearAllObj = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
        ctrl.stickyList = {};
        // Object.keys(ctrl.stickyList).forEach((key) => ctrl.stickyList[key] = []);
        // ctrl.warningOpen = false;
        // ctrl.warningMsg = ""
    };
    NColumnCanvasComponent.prototype.initCanvasData = function (res) {
        var ctrl = this;
        var issueConfig = ctrl.utilsService.getIssueConfigFromStorage(true);
        ctrl.issueConfigWithTitle = ctrl.utilsService.getIssueConfigWithTitle(res['CanvasConfig']);
        ctrl.colWidthPerc = (100 / (parseInt(issueConfig.colCount) + 1)) + "%";
        // Iterate objects
        Object.keys(res['NColCanvasSwotData']).forEach(function (key) {
            ctrl.stickyList[key] = res['NColCanvasSwotData'][key].map(function (item) { return ctrl.formatIssueData(item); });
        });
        ctrl.modalData = {
            distInputs: res['ColHeaders'],
            inputTypeLt: res['RadioOrCheckBox'],
            npvData: res['NPVSwing']
        };
    };
    NColumnCanvasComponent.prototype.showNoteDialog = function () {
        console.log('showNoteDialog');
    };
    return NColumnCanvasComponent;
}());
exports.NColumnCanvasComponent = NColumnCanvasComponent;
function getDropDetails(ev) {
    ev.preventDefault();
    var data = ev.originalEvent.dataTransfer.getData('text/plain');
    var draggable = document.getElementById(data);
    var textarea = draggable.getElementsByTagName('textarea');
    var nameGot = textarea[0].value;
    var dfv = data.split(":")[0];
    var id = parseInt(data.split(":")[1]);
    return { nameGot: nameGot, dfv: dfv, id: id };
}
angular.module('smartorg.r6.acts.nColumnCanvas', []).component('nColumnCanvas', {
    template: require('./n-column-canvas.component.html'),
    controller: NColumnCanvasComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
})
    .directive('noteCanvas', function ($document) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: '<div class="note"><div class="noteBody" ng-transclude></div></div>',
        link: function (scope, element, attr) {
            element.on('dragstart', function (ev) {
                scope.$emit('DragStart', { 'id': ev.target.id });
                ev.originalEvent.dataTransfer.setData('text/plain', ev.target.id);
                setTimeout(function () {
                    // element.addClass('lowOpacity');
                    // ev.target.classList.add('hide');
                }, 0);
                if (ev.target.id.indexOf('default') !== -1) {
                    scope.$emit('CopiedFromAllStickies', { 'status': true });
                }
                else {
                    scope.$emit('CopiedFromAllStickies', { 'status': false });
                }
                scope.$apply();
            });
            element.on('dragend', function (ev) {
                scope.$emit('DragEnd', { 'id': ev.target.id });
                // ev.originalEvent.dataTransfer.setData('text/plain', ev.target.id);
                // setTimeout(() => {
                //     // element.addClass('lowOpacity');
                //     // ev.target.classList.add('hide');
                // }, 0);
                // if (ev.target.id.indexOf('default') !== -1) {
                //     scope.$emit('CopiedFromAllStickies', { 'status': true });
                // } else {
                //     scope.$emit('CopiedFromAllStickies', { 'status': false });
                // }
                scope.$apply();
            });
        }
    };
})
    .directive('dragDropAddStickiesCanvas', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                // event.preventDefault();
                scope.$emit('DragOver', { 'type': 'DEFAULT', 'container': element, 'event': event });
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, dfv = _a.dfv, id = _a.id;
                scope.$emit('DropAddStickies', { 'issue': nameGot, dfv: dfv, id: id, 'container': element });
            });
        }
    };
})
    .directive('dragDropCanvas', function () {
    return {
        link: function (scope, element, attr) {
            // element.on('dragenter', function (ev) {
            //     console.log(ev);
            //     scope.$emit('DragEnter', { 'type': 'FEASIBILITY' });
            //  });
            element.on('dragover', function (event) {
                event.preventDefault();
                scope.$emit('DragOver', { 'type': attr.type, 'container': element, 'event': event });
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), nameGot = _a.nameGot, dfv = _a.dfv, id = _a.id;
                scope.$emit('Drop', { 'issue': nameGot, dfv: dfv, id: id, 'container': element, type: attr.type });
            });
        }
    };
});
module.exports = 'smartorg.r6.acts.nColumnCanvas';
//# sourceMappingURL=n-column-canvas.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/n-column-canvas/n-column-canvas.component.js